import { hot } from 'react-hot-loader/root'
import React, { Component } from 'react'
import { Provider } from 'react-redux'
import axios from 'axios'
import { SWRConfig } from 'swr'
import DatePicker, { registerLocale } from 'react-datepicker'
import sv from 'date-fns/locale/sv'

import { store } from './store'
import Router from './routes/router'
import setAuthorizationToken from './components/Auth/utils/setAuthorizationToken'

if (process.env.NODE_ENV === 'production') {
  const interval = setInterval(() => {
    const { admin } = store.getState().collectionData

    if (admin && admin.user && admin.user._id && !admin.user.shouldHideIntercom) {
      clearInterval(interval)
      window.Intercom('boot', { app_id: 'w3taakj6', email: admin.user.email, name: admin.user.name })
    }
  }, 1000) 
}

registerLocale('sv', sv)

DatePicker.defaultProps.locale = 'sv'

class AppProvider extends Component {
  constructor(props) {
    super(props)
    this.state = {
      rehydrated: false,
    }
  }

  componentWillMount() {
    if (localStorage.token) {
      setAuthorizationToken(localStorage.token)
    }
    this.setState({ rehydrated: true })

    // sätt globalt state för att underlätta hantering av mobil-vy
    window.isMobile = window.innerWidth < 540

    console.log(`isMobile: ${window.isMobile}`)
  }

  render() {
    if (!this.state.rehydrated) {
      return (
        <div>
          <h3 style={{ textAlign: 'center' }}>Laddar...</h3>
        </div>
      )
    }
    return (
      <SWRConfig
        value={{
          refreshInterval: 0,
          fetcher: (...args) => axios.get(...args).then(({ data }) => data),
        }}
      >
        <Provider store={store}>
          <Router />
        </Provider>
      </SWRConfig>
    )
  }
}

export default process.env.NODE_ENV.includes('dev') ? hot(AppProvider) : AppProvider
